/*
 * Return Array If Not
 - - - - - - - - - - - -
 Checks if a value is an array, and if not, returns it wrapped in an array
 @param val: value to be checked
 */
export const makeArrayIfNot = <T>(val: T | T[]) => {
  return Array.isArray(val) ? val : [val];
};
